import React, { useEffect } from "react";

const RingCentralWidget = () => {
  useEffect(() => {
    const embeddableScript = document.createElement("script");
    embeddableScript.src =
      "https://apps.ringcentral.com/integration/ringcentral-embeddable/2.2.0/adapter.js?clientId=a0TBhlwlHEJfWE3xWKO02V";
    embeddableScript.async = true;
    document.body.appendChild(embeddableScript);

    // Load Click-to-Dial script
    const c2dScript = document.createElement("script");
    c2dScript.src = "https://unpkg.com/ringcentral-c2d@1.0.0/build/index.js";
    c2dScript.async = true;
    document.body.appendChild(c2dScript);

    const forceOnTop = () => {
      const widget = document.querySelector("#rc-widget");
      if (widget) {
        widget.style.zIndex = "999999";
        widget.style.position = "fixed";
        widget.style.right = "20px";
        widget.style.bottom = "20px";
      }
    };

    // Mutation observer to reapply styles whenever widget DOM changes
    const observer = new MutationObserver(() => {
      forceOnTop();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });

    forceOnTop();

    return () => {
      observer.disconnect();
      document.body.removeChild(embeddableScript);
      document.body.removeChild(c2dScript);
    };
  }, []);

  return null;
};

export default RingCentralWidget;
